<template>
<div id='member'>

<div class="d-none d-sm-block">
<b-row  v-for="member in $t('message.members_list')" :key='member.name' > 

<b-col class="col-2"></b-col>
<b-col class="col-2">
<b-avatar :src=member.link size="8rem"></b-avatar>

<br><br>

</b-col>
<b-col class="col-6">
<div>
            <h3>{{member.name}}</h3>
            <h4>{{member.role}}</h4>

</div>
</b-col>
<b-col class="col-2"></b-col>

</b-row> 

</div>


<div class="d-block d-sm-none">
<b-row v-for="member in $t('message.members_list')" :key='member.name'  > 


<b-col class="col-4">  
  <div>
  <b-avatar :src=member.link size="6rem"></b-avatar>
  
  </div>
  
</b-col>
            
            
<b-col class="col-8">  
<h6><br>{{member.name}}<br>{{member.role}}</h6>
</b-col>

</b-row> 
</div>




</div>
</template>

<script>

/*
https://i.ibb.co/ZLSbgtr/trusha-4-square.jpg
https://i.ibb.co/nD6LpPx/miroslava-2-square.jpg
https://i.ibb.co/GMrzxsh/dmytro-1-square.png
https://i.ibb.co/LhXdy7z/aleksey-2-square.png

*/

import PostsService from '@/services/PostsService';


export default {
  name: 'Member',
  data: function() {
    return {
        members: [] , 
    };
  }, 
  
  methods: {
      async getMembers () {
      const response = await PostsService.fetchMembers()
      this.members = response.data
       
      },

      async getNewMembers () {
      const response = await PostsService.fetchNewMembers()
      this.members = response.data
      
      },

     
  },



  mounted () {
    // this.getAnounces()  - выводить все анонсы, а не только новые
    // this.getNewAnounces() - только новые анонсы, у которых New ='true'
         // this.getAnounces()
          this.getNewMembers()
  }
}

</script>





<style>

@import url('https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@300&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Balsamiq+Sans&display=swap');

@import url('https://fonts.googleapis.com/css2?family=Fira+Sans&display=swap');
 h1, h2, h3, h4, h5, h6 { font-family: 'Fira Sans', sans-serif; }




h3.textcenter {
   text-align: center  
}

h2.textcenter {
   text-align: center  
}

h1.textcenter {
   text-align: center  
}

</style>